// extracted by mini-css-extract-plugin
module.exports = {"root":"SingleVideo-module--root--w6uMg","container":"SingleVideo-module--container--1Av99","video":"SingleVideo-module--video--3uc9S"};